/* ============================================================
   MONARCA LIVING — Product Page JS
   assets/monarca-product.js
   ============================================================ */

(function () {
  'use strict';

  function init() {

    // ─── THUMBNAIL GALLERY ────────────────────────────────────
    var featuredImg = document.getElementById('mlv-featured-img');
    var thumbsTrack = document.getElementById('mlv-thumbs-track');
    var thumbPrev   = document.getElementById('mlv-thumb-prev');
    var thumbNext   = document.getElementById('mlv-thumb-next');

    if (thumbsTrack) {
      var thumbs = thumbsTrack.querySelectorAll('.mlv-product__thumb');
      var activeIndex = 0;

      // Find whichever thumb starts active (default: first)
      thumbs.forEach(function (t, i) {
        if (t.classList.contains('is-active')) activeIndex = i;
      });

      function selectThumb(index) {
        var count = thumbs.length;
        if (count === 0) return;
        // Loop around instead of stopping at the ends
        index = ((index % count) + count) % count;
        activeIndex = index;

        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        var activeThumb = thumbs[activeIndex];
        activeThumb.classList.add('is-active');

        if (featuredImg) {
          featuredImg.src = activeThumb.getAttribute('data-media-src');
          featuredImg.alt = activeThumb.getAttribute('data-media-alt') || '';
        }
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          selectThumb(i);
        });
      });

      // Thumb navigation (arrows) — only moves the active selection,
      // the thumbnail row itself stays in place.
      if (thumbPrev) {
        thumbPrev.addEventListener('click', function () {
          selectThumb(activeIndex - 1);
        });
      }

      if (thumbNext) {
        thumbNext.addEventListener('click', function () {
          selectThumb(activeIndex + 1);
        });
      }

      // Left/right swipe support on the thumbnail strip
      var touchStartX = 0;
      var touchEndX = 0;

      thumbsTrack.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      thumbsTrack.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var delta = touchEndX - touchStartX;
        var SWIPE_THRESHOLD = 40;

        if (delta > SWIPE_THRESHOLD) {
          selectThumb(activeIndex - 1); // swipe right -> previous
        } else if (delta < -SWIPE_THRESHOLD) {
          selectThumb(activeIndex + 1); // swipe left -> next
        }
      }, { passive: true });
    }

    // ─── MAIN IMAGE ZOOM (hover magnify) ──────────────────────
    var mainImgWrap = document.getElementById('mlv-main-img');
    var zoomBtn      = document.getElementById('mlv-zoom-btn');

    if (mainImgWrap && featuredImg) {
      var isZoomed = false;

      // Ensure the zoom effect is clipped even if theme CSS doesn't
      // already set this on the wrapper.
      mainImgWrap.style.overflow = 'hidden';
      featuredImg.style.transition = 'transform 0.15s ease-out';
      featuredImg.style.cursor = 'zoom-in';

      function setZoomed(state) {
        isZoomed = state;
        mainImgWrap.classList.toggle('is-zoomed', isZoomed);
        if (isZoomed) {
          // Apply zoom immediately (centered) so clicking shows an
          // instant effect instead of waiting for the mouse to move.
          featuredImg.style.transformOrigin = '50% 50%';
          featuredImg.style.transform = 'scale(2)';
        } else {
          featuredImg.style.transform = '';
          featuredImg.style.transformOrigin = '';
        }
      }

      if (zoomBtn) {
        zoomBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          setZoomed(!isZoomed);
        });
      }

      mainImgWrap.addEventListener('mousemove', function (e) {
        if (!isZoomed) return;
        var rect = mainImgWrap.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        featuredImg.style.transformOrigin = x + '% ' + y + '%';
        featuredImg.style.transform = 'scale(2)';
      });

      mainImgWrap.addEventListener('mouseleave', function () {
        if (isZoomed) setZoomed(false);
      });
    }

    // ─── QTY SELECTOR ────────────────────────────────────────
    var qtyInput = document.getElementById('mlv-qty-input');
    var qtyMinus = document.getElementById('mlv-qty-minus');
    var qtyPlus  = document.getElementById('mlv-qty-plus');

    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) {
          qtyInput.value = val - 1;
        }
      });

      qtyPlus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });

      qtyInput.addEventListener('change', function () {
        var val = parseInt(qtyInput.value, 10);
        if (!val || val < 1) qtyInput.value = 1;
      });
    }

    // ─── VARIANT SELECTION ───────────────────────────────────
    var form = document.getElementById('mlv-product-form');
    if (!form) return;

    var variantIdInput = document.getElementById('mlv-variant-id');
    var addBtn         = document.getElementById('mlv-add-btn');
    var buyNowBtn      = document.getElementById('mlv-buynow-btn');
    var priceEl        = document.getElementById('mlv-price');

    // Gather all option radios
    var optionInputs = form.querySelectorAll('.mlv-product__swatch-input, .mlv-product__pill-input');

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var optionIndex = parseInt(input.getAttribute('data-option-index'), 10);

        // Update displayed option value label
        var label = document.getElementById('mlv-option-val-' + (optionIndex + 1));
        if (label) label.textContent = input.value;

        // Update active swatch/pill UI
        var siblings = form.querySelectorAll('[data-option-index="' + optionIndex + '"]');
        siblings.forEach(function (sib) {
          sib.parentElement.classList.remove('is-selected');
        });
        input.parentElement.classList.add('is-selected');

        // Build selected options array
        var selectedOptions = [];
        for (var i = 0; i < 3; i++) {
          var checked = form.querySelector('[data-option-index="' + i + '"]:checked');
          if (checked) selectedOptions.push(checked.value);
        }

        // Find matching variant via productJSON global
        if (window.__monarcaProductJSON) {
          var variants = window.__monarcaProductJSON.variants;
          var match = variants.find(function (v) {
            return v.options.every(function (opt, idx) {
              return !selectedOptions[idx] || opt === selectedOptions[idx];
            });
          });

          if (match) {
            // Update hidden variant ID
            if (variantIdInput) variantIdInput.value = match.id;

            // Update price
            if (priceEl) {
              var price = (match.price / 100).toFixed(2);
              priceEl.textContent = '$' + price;
            }

            // Update add to cart button
            if (addBtn) {
              if (match.available) {
                addBtn.disabled = false;
                addBtn.textContent = 'ADD TO CART';
              } else {
                addBtn.disabled = true;
                addBtn.textContent = 'SOLD OUT';
              }
            }

            // Keep the Buy It Now fallback link in sync with the variant,
            // and block it when that variant is sold out.
            if (buyNowBtn) {
              buyNowBtn.href = '/cart/' + match.id + ':1';
              buyNowBtn.setAttribute('aria-disabled', match.available ? 'false' : 'true');
              buyNowBtn.style.opacity = match.available ? '' : '0.5';
              buyNowBtn.style.pointerEvents = match.available ? '' : 'none';
            }

            // Update featured image if variant has one
            if (match.featured_image && featuredImg) {
              featuredImg.src = match.featured_image.src;
            }
          }
        }
      });
    });

    // ─── BUY IT NOW ──────────────────────────────────────────
    // The old link (/checkout?variant=ID) is not something Shopify supports,
    // so it never added the product. Now: add the selected variant + quantity
    // to the cart, then send the customer straight to checkout.
    if (buyNowBtn) {
      // Valid fallback if JS ever fails: Shopify cart permalink.
      if (variantIdInput && variantIdInput.value) {
        buyNowBtn.setAttribute('href', '/cart/' + variantIdInput.value + ':1');
      }

      var buyNowLabel = (buyNowBtn.textContent || 'BUY IT NOW').trim();

      buyNowBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (buyNowBtn.getAttribute('aria-disabled') === 'true') return;
        if (buyNowBtn.getAttribute('data-busy') === '1') return;

        var variantId = variantIdInput ? variantIdInput.value : '';
        if (!variantId) return;
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

        buyNowBtn.setAttribute('data-busy', '1');
        buyNowBtn.textContent = 'PLEASE WAIT...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              return { ok: res.ok, data: data };
            });
          })
          .then(function (result) {
            if (!result.ok || (result.data && result.data.status)) {
              throw new Error('Could not add to cart');
            }
            window.location.href = '/checkout';
          })
          .catch(function () {
            buyNowBtn.setAttribute('data-busy', '0');
            buyNowBtn.textContent = 'UNAVAILABLE';
            setTimeout(function () { buyNowBtn.textContent = buyNowLabel; }, 2000);
          });
      });

      // If the customer comes back with the browser Back button, reset the label.
      window.addEventListener('pageshow', function (evt) {
        if (evt.persisted) {
          buyNowBtn.setAttribute('data-busy', '0');
          buyNowBtn.textContent = buyNowLabel;
        }
      });
    }

    // ─── ADD TO CART ──────────────────────────────────────────
    // The header cart badge refreshes by itself (see mlv-site-header.liquid),
    // so this only needs to handle the button state.
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'ADDING...';
      }

      var formData = new FormData(form);
      var data = {
        id: formData.get('id'),
        quantity: formData.get('quantity') || 1
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(function (res) {
        return res.json().then(function (body) {
          return { ok: res.ok, body: body };
        });
      })
      .then(function (result) {
        if (!addBtn) return;
        addBtn.disabled = false;

        if (!result.ok || (result.body && result.body.status)) {
          addBtn.textContent = 'UNAVAILABLE';
        } else {
          addBtn.textContent = 'ADDED ✓';
        }

        setTimeout(function () {
          addBtn.textContent = 'ADD TO CART';
        }, 2000);
      })
      .catch(function () {
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = 'ADD TO CART';
        }
      });
    });

  }

  // Run once DOM is ready — this is the key fix: the script tag loads
  // before the section markup exists in the DOM, so getElementById calls
  // were all returning null and no listeners were ever attached.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();